(() => {
  const root = window.Shopify?.routes?.root || '/';
  let pending = Promise.resolve();
  let allowCheckout = false;

  function protectionKeys(element) {
    return JSON.parse(element.querySelector('[data-protection-keys]').textContent);
  }

  async function readProtection() {
    const current = document.querySelector('package-protection');
    if (!current) return null;
    const url = new URL(root + 'cart', window.location.origin);
    url.searchParams.set('section_id', current.dataset.sectionId);
    const response = await fetch(url, { cache: 'no-store' });
    if (!response.ok) throw new Error('Cart could not be checked');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const updated = html.querySelector('package-protection');
    if (!updated) throw new Error('Protection could not be checked');
    return updated;
  }

  async function removeInvalid(element) {
    if (Number(element.dataset.targetVariant) > 0 || protectionKeys(element).length === 0) return false;
    await updateProtection(element, false);
    window.location.assign(root + 'cart');
    return true;
  }

  async function updateProtection(element, selected) {
    const updates = Object.fromEntries(protectionKeys(element).map((key) => [key, 0]));
    const target = Number(element.dataset.targetVariant);
    if (selected && target > 0) updates[target] = 1;
    const response = await fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates,
        attributes: {
          insurance: selected && target > 0 ? 'true' : 'false',
          'decline-insurance': selected && target > 0 ? 'not-declined' : 'declined',
        },
      }),
    });
    const cart = await response.json();
    if (!response.ok || cart.errors) throw new Error('Protection could not be updated');
  }

  function showError() {
    const error = document.getElementById('cart-errors');
    const text = document.querySelector('package-protection')?.dataset.error;
    if (error) error.textContent = text || window.cartStrings.error;
  }

  function enqueue(action) {
    pending = pending.then(action).catch(showError);
    return pending;
  }

  class PackageProtection extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (event) => {
        if (event.target.name !== 'attributes[insurance]') return;
        const selected = event.target.checked;
        event.target.disabled = true;
        enqueue(async () => {
          const fresh = await readProtection();
          if (!fresh) return;
          await updateProtection(fresh, selected);
          window.location.assign(root + 'cart');
        }).finally(() => { event.target.disabled = false; });
      });
      if (Number(this.dataset.targetVariant) === 0 && protectionKeys(this).length > 0) {
        enqueue(async () => {
          const fresh = await readProtection();
          if (fresh) await removeInvalid(fresh);
        });
      }
    }
  }

  customElements.define('package-protection', PackageProtection);

  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    enqueue(async () => {
      const fresh = await readProtection();
      if (!fresh || await removeInvalid(fresh)) return;
      document.querySelector('package-protection')?.replaceWith(fresh);
    });
  });

  document.addEventListener('submit', (event) => {
    if (allowCheckout || event.submitter?.name !== 'checkout' || !document.querySelector('package-protection')) return;
    event.preventDefault();
    const form = event.target;
    const button = event.submitter;
    button.disabled = true;
    enqueue(async () => {
      const fresh = await readProtection();
      if (!fresh || await removeInvalid(fresh)) return;
      allowCheckout = true;
      button.disabled = false;
      form.requestSubmit(button);
      allowCheckout = false;
    }).finally(() => { button.disabled = false; });
  }, true);
})();
